import Splide from "@splidejs/splide";

export default class SliderBlock {
	constructor() {
		this.events();
	}

	events() {
		this.initSliders();

		window.addEventListener("resize", this.initSliders);
		document.addEventListener("gutenbergWidthChanged", this.initSliders);

		if (window.acf) {
			window.acf.addAction("render_block_preview/type=slider-block", this.initSliders);
		}
	}

	initSliders() {
		let sliders = document.querySelectorAll(".splide.slider");

		sliders.forEach((slider) => {
			const splide = slider.splide;
			if (splide) {
				splide.destroy(true);
				slider.splide = null;
			}

			const newSplide = new Splide(slider, {
				type: "loop",
				perPage: 1,
				perMove: 1,
				pagination: true,
				arrows: false,
				rewind: true,
				gap: "2rem",
			}).mount();

			slider.splide = newSplide;
		});
	}
}
